module.exports = __webpack_public_path__ + "img/05.a584c03b.png";